<div class="modal-container" id="excelModal">
  <div class="modal-header">
    <h5 class="modal-title">{{ file.name }}</h5>
    <span *ngIf="title" class="ms-2 text-success fw-bold">- {{ title }}</span>
    <button class="btn-close" (click)="cancel()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body p-0">
    <div class="excel-table-container" id="tableContainer">
      <div class="table-wrapper">
        <table class="excel-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th *ngFor="let header of tableHeaders">
                {{ header }}
                <span *ngIf="requireEntriesList && isRequired(header)" class="text-danger">*</span>
              </th>
            </tr>
          </thead>

          <tbody id="tableBody">
            <tr *ngFor="let row of tableData; let rowIndex = index">
              <td>{{ rowIndex + 1 }}</td>
              <td *ngFor="let header of tableHeaders; let i = index" style="padding: 0px">
                <input
                  type="text"
                  [(ngModel)]="row[canonicalHeaders[i]]"
                  (ngModelChange)="onCellValueChange(rowIndex, i, $event)"
                  [ngClass]="{
                    'table-input': true,
                    invalid: validationState[rowIndex]?.[canonicalHeaders[i]] === false,
                    valid: validationState[rowIndex]?.[canonicalHeaders[i]] === true
                  }"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="table-info">
      <span class="text-muted">
        <i class="bi bi-table me-1"></i>
        Showing {{ tableData.length }} rows, {{ tableHeaders.length }} columns
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn-outline-custom" (click)="cancel()">
      Cancel
    </button>

    <button type="button" class="universal-submit-btn" (click)="confirm()">
      <i class="bi bi-check-circle me-1"></i>
      Confirm & Import
    </button>
  </div>
</div>